import { useContextState } from "../../../../../../hooks/theme"


export const useStyles = () => {
  const { colors } = useContextState()
  return {
    titleFolio: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'end',
      marginBottom:1
    },
    subTitle: {
      fontSize: '16px',
      fontWeight: '600',
      color: colors.color13,
    },
    headerActions: {
      display: 'flex',
      justifyContent: 'center',
      flex: 'wrap',
      height: 'fit-content',
      alignItems: 'end',
      marginBottom: 2,
      flexDirection: 'column'
      // padding: '0px 25px 0px',
    },
    finishBtn: {
      display: 'flex',
      alignItems: 'center',
      gap: 1
    },
    finishBtnDerlete: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'end',
      gap: 1
    },
    all: {
      display: 'flex',
      alignItems: 'center',
      '& .remove-m': {
        margin: '0px'
      }
    },
    select: {
      color: colors.color16,
      fontWeight: '500',
      fontSize: '11px',
      padding: '0px 4px',
      cursor: 'pointer',
    },
    line: {
      color: colors.color16,
      lineHeight: '2.5',
      fontSize: '13px',
    },
    clean: {
      fontSize: '2.4rem',
      color: colors.color4,
      padding: '6px',
      '& .MuiSvgIcon-root': {
        fontSize: '1em',
      },
      position:'absolute'
    },
    hide: {
      visibility: 'hidden',
    },
    section: {
      marginBottom: '32px',
    },
    containerButtons: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
  }
}
